// extracted by mini-css-extract-plugin
export var editButton = "_lr-0";